<template>
  <div class="loader">
    <div class="point"></div>
    <icon-loader-triangle-1 class="icon" id="first"></icon-loader-triangle-1>
    <icon-loader-triangle-2 class="icon" id="second"></icon-loader-triangle-2>
    <icon-loader-triangle-3 class="icon" id="third"></icon-loader-triangle-3>
  </div>
</template>

<script>
export default {
  mounted() {
    let first = document.getElementById("first");
    let second = document.getElementById("second");
    let third = document.getElementById("third");
    first.style.visibility = "visible";
    first.style.opacity = 1;
    second.style.visibility = "hidden";
    second.style.opacity = 0;
    third.style.visibility = "hidden";
    third.style.opacity = 0;

    setInterval(() => {
      if (first.style.visibility == "visible") {
        first.style.visibility = "hidden";
        first.style.opacity = 0;
        second.style.visibility = "visible";
        second.style.opacity = 1;
        return;
      }
      if (second.style.visibility == "visible") {
        second.style.visibility = "hidden";
        second.style.opacity = 0;
        third.style.visibility = "visible";
        third.style.opacity = 1;
        return;
      }
      if (third.style.visibility == "visible") {
        third.style.visibility = "hidden";
        third.style.opacity = 0;
        first.style.visibility = "visible";
        first.style.opacity = 1;
        return;
      }
    }, 1000);
  },
};
</script>

<style  scoped>
.loader {
  position: relative;
}
.point {
  z-index: 101;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  position: absolute;
  top: 0px;
  left: 35px;
  animation: point-anim 3s linear infinite;
  animation-delay: 0.5s;
  background-color: #006eff;
}
.icon {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 100;
  transition: visibility 0.5s, opacity 0.5s ease-in-out;
}
@keyframes point-anim {
  0% {
    top: 0px;
    left: 35px;
  }
  33% {
    top: 61px;
    left: 74px;
  }
  66% {
    top: 61px;
    left: -2px;
  }
  100% {
    top: -1px;
    left: 34px;
  }
}
</style>
